import Request from "./request";
import {localeGet} from "./api";

export default function() {
	const localeName = Request.params['lang'] ? Request.params['lang'].toLowerCase() : (Object.keys(window.locale || []).shift() || 'ru');
	const locales = window.locale || {};

	this.getName = () => localeName;

	this.getDict = (localeName) => {
		if (typeof locales[localeName] === 'undefined') {
			localeGet(localeName)
				.then(data => locales[localeName] = data)
				.finally(() => {
					locales[localeName] = false;
					console.error('cant find locale file for: ' + localeName);
				})
			;
		}

		return locales[localeName] || this.getDict('ru');
	};

	this.get = (key, args) => {
		try {
			const locale = this.getDict(localeName);
			if (!(key in locale)) {
				return '';
			}
            let result  = locale[key];
            result = typeof(result) === 'string' ?
	            result.replace(/{([-_\w]+)}/g, function(all, v) { return args[v] || all; })
	            : result;
			return result;
		} catch(e) {
			console.error('cant find locale key: ' + key);
			return '';
		}
	};

	this.getDate = (num, type) => {
		const names = this.get('date.' + type);
		const subNum = parseInt(('' + num).substr(-1));
		if(num >= 10 && num <= 20) return names[1];
		if(subNum >= 5) return names[1];
		if(subNum >= 2) return names[2] || names[1];
		if(subNum === 1) return names[0];
		if(subNum === 0) return names[1];
	};

    this.getProperty = (object, key, defaultValue) => {
        const camelCaseKey = key + localeName.substring(0, 1).toUpperCase() + localeName.substring(1).toLowerCase();
        if (object.hasOwnProperty(camelCaseKey)) {
            return object[camelCaseKey];
        }
        const snakeCaseKey = key + '_' + localeName.toLowerCase().substring(0, 2);
        if (object.hasOwnProperty(snakeCaseKey)) {
            return object[snakeCaseKey];
        }
        return defaultValue;
    };

};
